import { SHOP_ACTIONS } from "./actionTypes";

const initState = {
  stats: {
    totalSales: 0,
    totalCustomers: [],
    noOfOrders: 0,
  },
  customers: [],
  orders: [],
  isFetching: false,
  updatesList: [],
};

export const actions = {
  setIsFetching: (key, data = null) => ({
    type: SHOP_ACTIONS.IS_FETCHING,
  }),
  setStats: (data) => ({
    type: SHOP_ACTIONS.SET_STATS,
    payload: data,
  }),
  setCustomers: (data) => ({ type: SHOP_ACTIONS.SET_CUSTOMERS, payload: data }),
  setOrders: (data) => ({ type: SHOP_ACTIONS.SET_ORDERS, payload: data }),
  setUpdates: (data) => ({ type: SHOP_ACTIONS.SET_UPDATES, payload: data }),
};

const shopReducer = (state = initState, action) => {
  switch (action.type) {
    case SHOP_ACTIONS.IS_FETCHING: {
      return {
        ...state,
        isFetching: !state.isFetching,
      };
    }
    case SHOP_ACTIONS.SET_STATS: {
      return {
        ...state,
        stats: action.payload,
      };
    }
    case SHOP_ACTIONS.SET_CUSTOMERS: {
      return {
        ...state,
        customers: action.payload,
      };
    }
    case SHOP_ACTIONS.SET_ORDERS: {
      return {
        ...state,
        orders: action.payload,
      };
    }
    case SHOP_ACTIONS.SET_UPDATES: {
      return {
        ...state,
        updatesList: action.payload,
      };
    }
    default:
      return state;
  }
};
shopReducer.initialState = initState;

export default shopReducer;
